// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"350":"7d9b55e2","446":"e0554c24"}[chunkId] + ".chunk.css";
};